import {enqueue} from 'src/offline/outbox';
import {ensureCapacity} from 'src/offline/quota';
import {isResizableImage, resizeImage} from 'src/shared/utils/imageResize';
import {applyAddAttachment} from './appliers';
import {INSPECTION_OUTBOX_KINDS} from './executors';
import {inspectionContextKey} from './snapshotKeys';

export interface EnqueuePhotoCaptureArgs {
  inspectionId: number;
  deviceId: number;
  file: File;
}

// Quota-checks then atomically stores the captured blob and queues its upload,
// appending a photo reference to the device's local entry snapshot.
export const enqueuePhotoCapture = async ({
  inspectionId,
  deviceId,
  file,
}: EnqueuePhotoCaptureArgs): Promise<void> => {
  let resized = file;
  if (isResizableImage(file)) {
    try {
      resized = await resizeImage(file);
    } catch {
      // Fall back to the original file so an offline capture is never dropped.
      resized = file;
    }
  }

  await ensureCapacity(resized.size);
  await enqueue({
    kind: INSPECTION_OUTBOX_KINDS.addAttachment,
    payload: {inspectionId, deviceId, name: resized.name},
    contextKey: inspectionContextKey(inspectionId),
    applyLocal: ctx =>
      applyAddAttachment(
        {
          inspectionId,
          deviceId,
          name: resized.name,
          contentType: resized.type,
          blob: resized,
        },
        ctx
      ),
  });
};

/** Temp id for a device created offline before the server assigns a real one. */
export const newTempDeviceId = (): number =>
  -(Date.now() * 1000 + Math.floor(Math.random() * 1000));
